// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import { StreamActions, visit } from "@hotwired/turbo"
import "@rails/ujs"
import "./controllers"
import "./channels"
import { installExclusivePopoverGuard } from "./utils/exclusive-popover.util"

import LocalTime from "local-time"
LocalTime.start()
installExclusivePopoverGuard()

// <turbo-stream action="visit" url="…">: navigates from a fetch() that rendered a stream (the
// statement import modal sends a single CSV straight to its column-mapping page). Turbo has no
// built-in redirect action.
StreamActions.visit = function () {
  visit(this.getAttribute("url"))
}
